import React from "react";
import "../themes/css/loading.css";

const Loading = () => {
  return <div className="bg-primary loader">Loading...</div>;
};

export default Loading;
